var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tw-flex align-items-center border rounded-pill block-status status-white pr-2",class:{ 'pl-1': _vm.displayIcon, 'pl-2': !_vm.displayIcon }},[(_vm.displayIcon)?_c('span',{staticClass:"status-icon",class:_vm.iconClass}):_vm._e(),_c('span',{staticClass:"status-text tx-weight-bold"},[_vm._v(_vm._s(_vm.copy))])])
}
var staticRenderFns = []

export { render, staticRenderFns }